module.exports = __webpack_public_path__ + "static/media/serviceBg.4177d61d.png";